module.exports = __webpack_public_path__ + "img/copy.03a765d6.svg";